import { colors } from 'style'
import styled from 'styled-components'

const SetupGuideContainer = styled.div`
  margin-bottom: 25px;

  .book-setup-guide {
    .book-setup-guide-container {
      .book-setup-guide-container-content {
        height: 725px;
      }

      .note {
        margin: 20px 0;
        border: 1px solid;
        padding: 8px;
        font-weight: bold;
      }

      .actions {
        padding: 8px;
        .btn {
          width: 150px;
        }
      }

      h4 {
        font-size: 16px;
      }
    }

    .card-body-author-container .progressbar-container {
      overflow-y: auto;
    }
  }

  @media (min-width: 901px) {
    .card-body-container .container {
      max-width: 100% !important;
      min-width: 100% !important;
    }

    .card-body-save-container .customContainer {
      padding: 0px 50px;
      background: white;
      margin-bottom: 15px;
      width: 60% !important;
      max-width: 100% !important;
      min-width: 100% !important;
    }

    .card-body-save-container .customContainer.customContainerPadding {
      padding: 20px 50px;
    }

    .card-body-story-container {
      .card-body {
        padding-top: 0;
      }

      .prompts-container {
        width: 100%;
        overflow-x: clip;
      }
    }

    .book-setup-guide
      .card-body-container
      .progressbar-container.progressbar-box {
      padding-left: 180px !important;
      padding-right: 180px !important;
    }
  }

  @media (max-width: 900px) {
    .card-body-save-container .customContainer .col-md-3 {
      text-align: -webkit-center;
    }

    .card-body-save-container .customContainer .col-md-9 {
      text-align: center;
    }

    .card-body-save-container .customContainer {
      padding: 10px 0px;
      width: 100%;
      max-width: 100% !important;
      min-width: 100% !important;
      background: white;
      margin-bottom: 15px;
    }

    .book-setup-guide .wizard-container .card-body-save-container {
      max-height: 565px;
      overflow-y: scroll;
    }

    .book-setup-guide
      .wizard-container
      .card-body-save-container::-webkit-scrollbar {
      // display: none;
    }

    .book-setup-guide
      .wizard-container
      .card-body-author-container::-webkit-scrollbar,
    .book-setup-guide
      .wizard-container
      .card-body-info-container::-webkit-scrollbar,
    .book-setup-guide
      .wizard-container
      .card-body-story-container::-webkit-scrollbar {
      // display: none;
    }
  }

  .card-body-save-container .customContainer,
  .book-setup-guide-container-content {
    border-radius: 15px;
  }

  .book-setup-guide-container-content .card.card-header {
    border-radius: unset !important;
  }

  .book-setup-guide .ant-header {
    background: #4c4c4c !important;
  }

  .book-setup-guide .ant-close {
    color: white !important;
  }

  .book-setup-guide .ant-header .ant-title {
    color: white !important;
  }

  .book-setup-guide .ant-body {
    padding: 0 !important;
  }

  .book-setup-guide .ant-content {
    background: #f2f2f2 !important;
  }

  .book-setup-guide .card-header,
  .book-setup-guide .card-body {
    background: white;
  }

  .book-setup-guide .book-setup-guide-container-content {
    background: white;
    padding: 15px 0px;
    margin: 25px 33px;
  }

  .book-setup-guide .wizard-container .book-setup-guide-container-content {
    background: #f2f2f2 !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .book-setup-guide
    .wizard-container
    .book-setup-guide-container-content
    .card-header {
    background: white;
  }
  .book-setup-guide
    .wizard-container
    .book-setup-guide-container-content
    .card-body {
    padding: 15px 0;
    margin: 10px 33px;
  }

  .book-setup-guide .wizard-container .card-body-info-container {
    max-height: 565px;
  }

  .book-setup-guide .multi-step-icon {
    margin-top: -49.5px;
    margin-left: 18.5px;
    position: absolute;
  }

  .book-setup-guide .progressbar-container {
    text-align: center;
    position: relative;
  }

  .book-setup-guide .card-body-container .progressbar-container {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .book-setup-guide .card {
    z-index: 0;
    border: none;
    border-radius: 15px !important;
  }

  .book-setup-guide .progressbar-tab {
    padding: 0;
    overflow: hidden;
    color: lightgrey;
  }

  .book-setup-guide .progressbar-tab .active {
    color: ${colors.blueDark};
  }

  .book-setup-guide .progressbar-tab .complete {
    color: ${colors.greenDark};
  }

  .book-setup-guide .progressbar-tab li {
    list-style-type: none;
    font-size: 15px;
    width: 25%;
    float: left;
    position: relative;
    font-weight: 400;
  }

  .book-setup-guide .progressbar-tab .book-info-icon:before {
    content: '';
    background-image: url(/RiEditFill.svg) !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
  }

  .book-setup-guide .progressbar-tab .book-author-icon:before {
    content: '';
    background-image: url(/MdContactMail.svg) !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
  }

  .book-setup-guide .progressbar-tab .book-people-icon:before {
    content: '';
    background-image: url(/MdPersonAdd.svg) !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
  }

  .book-setup-guide .progressbar-tab .book-story-icon:before {
    content: '';
    background-image: url(/FaBookMedical.svg) !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
  }

  .book-setup-guide .progressbar-tab li:before {
    width: 50px;
    height: 50px;
    line-height: 45px;
    display: block;
    font-size: 20px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
  }

  .book-setup-guide .progressbar-tab li:after {
    content: '';
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 25px;
    z-index: -1;
  }

  .book-setup-guide .card-body-container {
    display: flex;
    width: 100%;
    flex-direction: column;
  }

  .book-setup-guide .progressbar-tab li.active:before,
  .book-setup-guide .progressbar-tab li.active:after {
    background: ${colors.blueDark};
  }

  .book-setup-guide .progressbar-tab li.complete:before,
  .book-setup-guide .progressbar-tab li.complete:after {
    background: ${colors.greenDark};
  }

  .book-setup-guide
    .card-body-container
    .progressbar-container
    .e-input-group-icon {
    display: none;
  }

  .book-setup-guide .card-body-container .progressbar-container .e-input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: rgb(73, 80, 87);
    background-color: rgb(255, 255, 255);
    background-clip: padding-box;
    border: 1px solid rgb(206, 212, 218);
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out 0s,
      box-shadow 0.15s ease-in-out 0s;
  }

  .book-setup-guide .card-body-container .progressbar-container .btn-story {
    width: 100%;
    height: 35px;
    color: #333;
    padding: 0px 16px;
    background: white;
    border-color: #ccc;
    border-radius: 10px;
  }

  .book-setup-guide
    .card-body-container
    .progressbar-container
    .btn-story.active {
    color: white;
    border-color: ${colors.blueDark};
    background: ${colors.blueDark};
  }

  .book-setup-guide .card-body-container .progressbar-container .roles {
    display: flex;
    flex-direction: column;
    .ant-radio-group {
      .ant-space {
        width: 100%;
        gap: 10px !important;
        .ant-space-item {
          .ant-radio-wrapper {
            border: 1px solid ${colors.blueDark};
            border-radius: 15px;
            margin-right: 0;
            padding: 0 12px;
            align-items: center;
            height: 30px;
            width: 100%;
            &.ant-radio-wrapper-checked {
              background: ${colors.blueDark4};
            }
            .ant-radio-checked .ant-radio-inner {
              border-color: ${colors.blueDark};
              &::after {
                background-color: ${colors.blueDark};
              }
            }
          }
        }
      }
    }
  }

  .card-body-save-container .card {
    background: #f2f2f2 !important;
  }

  .customContainer .description {
    font-size: 18px;
  }

  .customContainer .btn-blueLight {
    width: 100%;
    border-radius: 5px;
    color: white;
    font-size: 20px;
    background-color: #007bff;
    padding: 0 16px;
  }

  .customContainer .btn-blueLight {
    width: 100%;
    border-radius: 5px;
    color: white;
    font-size: 20px;
    padding: 0 16px;
  }

  .btn-blueLight:active,
  .btn-blueLight:hover {
    background-color: ${colors.greenDark} !important;
    border-color: ${colors.greenDark} !important;
  }

  .customContainer.active {
    background: #f2f2f2 !important;
    padding: 0 !important;
  }

  .customContainer .story-img {
    width: 50px !important;
    height: 50px !important;
    background: #4c4c4c !important;
    border-radius: 50% !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .wizard-container .row,
  .customContainer .row {
    align-items: center !important;
  }

  .btn-setup-guide-group {
    border: 1px solid #4c4c4c;
    padding: 10px 20px;
    color: #4c4c4c;
    border-radius: 5px;

    &:hover {
      background-color: ${colors.blueDark};
      color: white;
      border: 1px solid ${colors.blueDark};
      cursor: pointer;
    }

    &:hover {
      svg {
        color: white !important;
      }
    }
  }

  @media (min-height: 1100px) {
    .book-setup-guide .card-body-container {
      height: 650px;
    }

    .card-body-story-container .prompts-container {
      max-height: 100%;
    }
  }
  @media (min-height: 1200px) {
    .book-setup-guide .card-body-container {
      height: 750px;
    }
  }
`

export default SetupGuideContainer
